//活动类型
const MERCHANTE_ACT_TYPE = 'merchantActType'; // 主题活动
const ROOM_ACT_TYPE = 'roomActType'; // 会场活动
const POOL_ACT_TYPE = 'poolActType'; // 收品池
const DAILY_TYPE = 'dailyType';
const STRATEGY_TYPE = 'strategyType';

// 主题活动导航栏下的类型集合
const merchant_crumb_type = [MERCHANTE_ACT_TYPE, ROOM_ACT_TYPE, POOL_ACT_TYPE, DAILY_TYPE, STRATEGY_TYPE];

export { MERCHANTE_ACT_TYPE, ROOM_ACT_TYPE, POOL_ACT_TYPE, DAILY_TYPE, STRATEGY_TYPE };

export default { merchant_crumb_type };

// 可以将任意活动类型组成一个集合，提供给导航栏进行筛选
